import { Typography, useTranslate } from '@prenuvo/halo';

import { SidePanel } from '@/shared/ui';

import { ActivityLogs } from './activity-logs';

interface ActivityLogsSidePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ActivityLogsSidePanel({ isOpen, onClose }: ActivityLogsSidePanelProps) {
  const translate = useTranslate();

  return (
    <SidePanel
      ariaLabel={translate('FCT.ACTIVITY_LOGS.TITLE') as string}
      isOpen={isOpen}
      onClose={onClose}
      title={<Typography translationKey="FCT.ACTIVITY_LOGS.TITLE" />}
      titleJustification="between"
    >
      {isOpen && <ActivityLogs />}
    </SidePanel>
  );
}
